import CrelanPaymentCard from './CrelanPaymentCard';

export default CrelanPaymentCard;
